export const CANCELLED = 'CANCELED';
export const NEW = 'NEW';
